module.exports = __webpack_public_path__ + "static/media/GANTS.7684666b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/GANTS.png
// module id = 254
// module chunks = 0